import React, { useEffect, useState } from 'react'
import DataTable from '../../../component/data-table/DataTable'
import CategoryListAction from '../../../component/data-table/data-table-action/vehicle-managment/CategoryListAction'
import { ToastContainer } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import { CategoryListRes, CategoryListTodo } from '../../../redux/slices/master_slice/vehical_category/CategoryList'
import Loader from '../../../component/loader/Loader'

export default function CategoryList(props) {
    const { bool, setBool } = props
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const categoryList = useSelector(state => state?.CategoryList?.data?.data)

    useEffect(() => {
        setLoading(true)
        dispatch(CategoryListTodo()).then(() => list_res())
    }, [bool])

    const list_res = () => {
        if (CategoryListRes?.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const columnDefs = [
        {
            headerName: 'S.NO',
            // valueGetter: 'node.rowIndex + 1',
            cellRenderer: params => params.node.rowIndex + 1,
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            // maxWidth: 130
        },
        {
            headerName: 'CATEGORY',
            field: 'vehicle_category_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'IMAGE',
            field: 'vehicle_category_image ',
            cellRenderer: params => <div className='table_img_sec'>
                <img className=" img-fluid table_data_img" src={process.env.REACT_APP_IMAGE_URL + params?.data?.vehicle_category_image } alt="image" />
            </div>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            autoHeight: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
        },

        {
            headerName: 'STATUS',
            field: 'vehicle_category_status',
            filter: 'agTextColumnFilter',
            cellRenderer: params => params.data.vehicle_category_status === 'active' ? <span className='badge text-bg-success'>Active</span> : <span className='badge text-bg-danger'>Inactive</span>,
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            field: 'ACTIONS',
            cellRenderer: CategoryListAction,
            cellRendererParams: {
                bool: bool,
                setBool: setBool,
            },
            // wrapText: true,
            autoHeight: true,
            pinned: 'right',
        }
    ]
    return (
        <>

            {loading ?
                <diV className='dd-flex justify-content-center mt-5 pt-5'>
                    <Loader />
                </diV> :
                categoryList && categoryList.length ?
                    <DataTable
                        rowData={categoryList}
                        columnDefs={columnDefs}
                        height={'60vh'}
                    />
                    :
                    <div className='empty_section'>
                        <span>DATA NOT FOUND</span>
                    </div>
            }

            <ToastContainer />
        </>
    )
}
